import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import {
  APQueryOptions,
  LONG_STALE_TIME,
  useAPQuery,
} from "../../providers/APQueryProvider";
import { PaginationResponse } from "../../types/Pagination";
import {
  APVehicleVariant,
  VehicleVariantSearchFilters,
} from "../../types/Vehicles";

export const searchVehicleVariants = (
  filters: VehicleVariantSearchFilters | null,
  options: APQueryOptions = {}
) => {
  const { nextPageLink, ...otherFilters } = filters || {};

  const { fetchWithAuth } = useApi();
  const { defaultOnMutateError, defaultOnMutateSuccess, isQueryEnabled } =
    useAPQuery();

  return useQuery({
    queryKey: ["searchVehicleVariants", filters],
    queryFn: (): Promise<PaginationResponse<APVehicleVariant>> => {
      return fetchWithAuth<PaginationResponse<APVehicleVariant>>(
        "searchVehicleVariants",
        undefined,
        {
          requestOptions: {
            method: "post",
            body: filters
              ? JSON.stringify({
                  ...otherFilters,
                  nextPage: nextPageLink ?? undefined,
                })
              : undefined,
          },
        }
      );
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    enabled: isQueryEnabled(options),
    staleTime: LONG_STALE_TIME,
    keepPreviousData: options.keepPreviousData,
  });
};
